export default {
  banner: ['Banco de', 'Talentos'],
  title: 'Regístrese en nuestro Banco de Talentos',
}
